// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const monitoringServicesResponseSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
  },
  {
    key: 'name',
    type: 'string',
    required: true,
    component: 'TextInput',
    fullPath: 'name',
  },
  {
    key: 'object',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'object',
    options: ['service'],
  },
  {
    key: 'gracePeriod',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'gracePeriod',
    numberFormat: 'integer',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['inactive', 'active'],
  },
  {
    key: 'monitorIntervalType',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'monitorIntervalType',
    options: ['weekly', 'monthly', 'hourly', 'daily'],
  },
  {
    key: 'monitorIntervalValue',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'monitorIntervalValue',
    numberFormat: 'integer',
  },
  {
    key: 'serviceType',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'serviceType',
    options: [
      'bankruptcy',
      'deceased',
      'federalEmergency',
      'militaryDuty',
      'oFACSanctionedIndividual',
      'reassignedNumbersDatabase',
    ],
  },
  {
    key: 'positiveRateThreshold',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'positiveRateThreshold',
    numberFormat: 'float',
  },
  {
    key: 'ignoreThresholdBelowTotalBorrowers',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'ignoreThresholdBelowTotalBorrowers',
    numberFormat: 'integer',
  },
  {
    key: 'hitMatchRequirements',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'hitMatchRequirements',
    nested: [
      {
        key: '0',
        type: 'object',
        required: true,
        component: 'TextInput',
        fullPath: 'hitMatchRequirements[0]',
        nested: [],
      },
    ],
  },
  {
    key: 'femaDisasterTypesTracked',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'femaDisasterTypesTracked',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'femaDisasterTypesTracked[0]',
      },
    ],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(monitoringServicesResponseSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(monitoringServicesResponseSchema)
}
